import { createTwoFilesPatch } from "diff";
import * as React from "react";
import { Diff, Hunk, markEdits, parseDiff, tokenize } from "react-diff-view";
import styled from "styled-components";

interface IProps {
    oldText: string;
    newText: string;
    oldVersion: string;
    newVersion: string;
}

function DiffText({ newText, oldText, oldVersion, newVersion }: IProps) {
    const diffText = React.useMemo(() => {
        const oldPath = `a/${oldVersion}`;
        const newPath = `b/${newVersion}`;
        const patch = createTwoFilesPatch(oldPath, newPath, oldText, newText, undefined, undefined, {
            context: Number.MAX_SAFE_INTEGER,
        });
        const patchBody = patch.startsWith("===================================================================")
            ? patch.split("\n").slice(1).join("\n")
            : patch;
        return `diff --git ${oldPath} ${newPath}\n${patchBody}`;
    }, [newText, newVersion, oldText, oldVersion]);
    const files = React.useMemo(() => parseDiff(diffText, { nearbySequences: "zip" }), [diffText]);
    const file = files[0];
    const tokens = React.useMemo(() => {
        if (!file) {
            return null;
        }
        return tokenize(file.hunks, {
            enhancers: [markEdits(file.hunks, { type: "line" })],
        });
    }, [file]);

    if (!file) {
        return null;
    }
    return (
        <div>
            <Header>
                <HeaderItem>{oldVersion}</HeaderItem>
                <HeaderItem>{newVersion}</HeaderItem>
            </Header>
            <Diff diffType={file.type} hunks={file.hunks} viewType="split" gutterType="none" tokens={tokens}>
                {(hunks) => hunks.map((hunk) => <Hunk key={hunk.content} hunk={hunk} />)}
            </Diff>
        </div>
    );
}

export default React.memo(DiffText);

const Header = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
`;

const HeaderItem = styled.div`
    padding: 0.25rem 0.5rem;
`;
